import React, { ChangeEvent, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { LinkConfigurationStepConfirmation } from '@app/api';
import { CheckboxBlockField } from '@app/form';
import { FormikValues, useFormikContext } from 'formik';

interface Props {
  linkConfigurationStep: LinkConfigurationStepConfirmation;
  children?: React.ReactNode;
}

export const LinkConfigurationCheckElement = ({
  linkConfigurationStep,
}: Props) => {
  const { t } = useTranslation();

  const { values, setFieldValue } = useFormikContext<FormikValues>();

  const onLinkConfigurationStepChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      const linkConfigurationStepConfirmation =
        values.linkConfigurationStepConfirmation || [];
      const step = e.target.value as LinkConfigurationStepConfirmation;
      if (!linkConfigurationStepConfirmation.includes(step)) {
        setFieldValue('linkConfigurationStepConfirmation', [
          ...linkConfigurationStepConfirmation,
          step,
        ]);
      } else {
        setFieldValue(
          'linkConfigurationStepConfirmation',
          linkConfigurationStepConfirmation.filter(
            (item: LinkConfigurationStepConfirmation) => item !== step,
          ),
        );
      }
      return;
    },
    [setFieldValue, values],
  );

  return (
    <CheckboxBlockField
      key={linkConfigurationStep}
      variant="green"
      value={linkConfigurationStep}
      name="linkConfigurationStepConfirmation"
      label={t(
        `editSession.linkConfiguration.stepCheck.${linkConfigurationStep}`,
      )}
      onChange={onLinkConfigurationStepChange}
      checked={values.linkConfigurationStepConfirmation?.includes(
        linkConfigurationStep,
      )}
    />
  );
};
